import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PayoutMethodsService } from '../../services/payout-methods.service';

@Component({
  standalone: false,
  selector: 'sbnb-direct-payouts-stripe-oauth-success',
  templateUrl: './direct-payouts-stripe-oauth-success.component.html',
  styleUrls: ['./direct-payouts-stripe-oauth-success.component.scss'],
})
export class DirectPayoutsStripeOauthSuccessComponent implements OnInit {
  code: string = '';
  payoutMethod: any = null;
  error: boolean;
  errorMessage: any;
  loading: boolean = false;

  redirect: string = '';

  constructor(
    private route: ActivatedRoute,
    private payoutMethodsService: PayoutMethodsService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.route.queryParamMap.subscribe((params) => {
      this.code = params.get('code');

      this.payoutMethodsService.createStripeOauthPayoutMethod(this.code).subscribe((res) => {
        this.loading = false;
        if (res.error) {
          this.error = true;
          this.errorMessage = res.message;
          return;
        }

        this.payoutMethod = res;

        // Fetch our redirect logic from LocalStorage
        this.redirect = localStorage.getItem('direct-stripe-redirect');

        if (this.redirect) {
          switch (this.redirect) {
            case 'activate':
              this.router.navigate(['/direct/plan'], { queryParams: { open: 'activate' } });
              break;

            case 'switch':
              this.router.navigate(['/direct/plan'], { queryParams: { open: 'switch' } });
              break;

            default:
              break;
          }
        } else {
          // If the payout method already is set to all properties, then we should redirect to the payouts page
          if (this.payoutMethod.all_properties) {
            this.router.navigate([`/direct/payouts`]);
          } else {
            this.router.navigate([`/direct/payouts/edit/${res.uuid}`, { combined: true }]);
          }
        }
      });
    });
  }
}
